import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {toast} from 'react-toastify'
import {UserModel} from '../../../modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {Link, useHistory} from 'react-router-dom'
import {
  IVehicleMakeModel,
} from '../../../models/vehicle-manage-model/IVehicleInfoModel'
import {GetVehicleMakeListAPI} from '../../../modules/vehicle-manage-master-page/vehicle-make-master-page/VehicleMakeCRUD'
import {
  INewModelRequest,
  newModelRequestInitValue as initialValues,
} from '../../../models/vehicle-manage-model/INewModelRequest'
import {getCustomerList} from '../../../modules/organization-page/customer-master-page/CustomerCRUD'
import {ICustomerListModel} from '../../../models/organization-page/customer/ICustomenrModel'
import {CreateNewModelRequestAPI} from '../../../modules/vehicle-manage-master-page/new-model-request-master-page/NewModelRequestCRUD'

const profileDetailsSchema = Yup.object().shape({
  vehicleMakeID: Yup.number()
    .required('Vehicle Make is required')
    .min(1, 'Vehicle Make is required'),
  vehicleModelID: Yup.number(),
  customerID: Yup.number().required('Customer is required').min(1, 'Customer is required'),
  vehicleModelName: Yup.string().required('Model Name is required'),
  noOfSeat: Yup.number().required('No of Seat is required').min(1, 'No of Seat is required'),
})

interface IItem {
  loading: boolean
  vehicleMakeData: IVehicleMakeModel[]
  NewModelRequestData: INewModelRequest[]
  customerData: ICustomerListModel[]
}

export const modelStatusData = [
  {statusID: 1, statusName: 'Open'},
  {statusID: 2, statusName: 'Close'},
]
const AddNewModelRequest: React.FC = () => {
  const [data, setData] = useState<INewModelRequest>(initialValues)
  const [isActive, setIsActive] = useState(false)
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const updateData = (fieldsToUpdate: Partial<INewModelRequest>): void => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }

  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const [state, setState] = useState<IItem>({
    loading: false,
    vehicleMakeData: [] as IVehicleMakeModel[],
    NewModelRequestData: [] as INewModelRequest[],
    customerData: [] as ICustomerListModel[],
  })

  useEffect(() => {
    setState({...state, loading: true})
    setTimeout(() => {
      getVehicleMakeData()
    }, 100)
  }, [])

  // ==================== Get Item API Call===================
  function getVehicleMakeData() {
    GetVehicleMakeListAPI()
      .then((response) => {
        let responseData = response.data.responseObject
        if (response.data.isSuccess === true) {
          getCustomerListData(responseData)
        } else {
          toast.error(`${response.data.message}`)
          setState({...state, vehicleMakeData: [], loading: false})
        }
      })
      .catch((error) => {
        toast.error(`${error}`)
        setState({...state, vehicleMakeData: [], loading: false})
      })
  }

  function getCustomerListData(temVehicleMakeData: IVehicleMakeModel[]) {
    getCustomerList()
      .then((response) => {
        let responseData = response.data.responseObject
        if (response.data.isSuccess === true) {
          setState({
            ...state,
            customerData: responseData,
            vehicleMakeData: temVehicleMakeData,
            loading: false,
          })
        } else {
          toast.error(`${response.data.message}`)
          setState({...state, customerData: [], loading: false})
        }
      })
      .catch((error) => {
        toast.error(`${error}`)
        setState({...state, customerData: [], loading: false})
      })
  }

  // ==================== Get Item API Call===================
  // function getVehicleModelData(temVecMakeID: number) {
  //   GetVehicleModelListByMakeIDAPI(temVecMakeID)
  //     .then((response) => {
  //       let responseData = response.data.responseObject
  //       if (response.data.isSuccess === true) {
  //         setState({
  //           ...state,
  //           vehicleModelData: responseData,
  //           loading: false,
  //         })
  //       } else {
  //         toast.error(`${response.data.message}`)
  //         setState({...state, vehicleMakeData: [], loading: false})
  //       }
  //     })
  //     .catch((error) => {
  //       toast.error(`${error}`)
  //       setState({...state, vehicleMakeData: [], loading: false})
  //     })
  // }

  const checkedFunction = (event: any) => {
    const value = event.target.checked
    const elementId = event.target.id
    if (elementId === 'IsActive') {
      setIsActive(value)
    }
  }

  const selectChange = (event: any) => {
    const value = event.target.value
    const elementId = event.target.id
    if (elementId === 'vehicleMakeID') {
      formik.setFieldValue('vehicleMakeID', parseInt(value))
      // getVehicleModelData(parseInt(value))
    } else if (elementId === 'customerID') {
      formik.setFieldValue('customerID', parseInt(value))
    }
  }

  const formik = useFormik<INewModelRequest>({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: (values) => {
      setLoading(true)
      setTimeout(() => {
        CreateNewModelRequestAPI(
          values.vehicleMakeID,
          values.customerID,
          1,
          values.vehicleModelName,
          values.noOfSeat
        )
          .then((response) => {
            if (response.data.isSuccess === true) {
              toast.success('Created Successfull')
              history.push('/vehicle/new-model-request/list')
            } else {
              toast.error(`${response.data.message}`)
            }
          })
          .catch((error) => {
            toast.error(`${error}`)
          })
        setLoading(false)
      }, 1000)
    },
  })

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9 ms-6'>
              <div className='row mb-6'>
                <label className='col-lg-2 col-form-label required fw-bold fs-6'>
                  Select Customer:
                </label>
                <div className='col-lg-4 fv-row'>
                  <select
                    className='form-select bg-light-primary'
                    aria-label='Default select example'
                    onChange={selectChange}
                    id='customerID'
                  >
                    <option selected value='0'>
                      Select Customer
                    </option>
                    {state.customerData.length > 0 &&
                      state.customerData.map((data, index) => {
                        return (
                          <option key={index} value={data.customerID}>
                            {data.customerName}
                          </option>
                        )
                      })}
                  </select>
                  {formik.touched.customerID && formik.errors.customerID && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.customerID}</div>
                    </div>
                  )}
                </div>

                <label className='col-lg-2 col-form-label required fw-bold fs-6'>
                  Vehicle Make:
                </label>
                <div className='col-lg-4 fv-row'>
                  <select
                    className='form-select bg-light-primary'
                    aria-label='Default select example'
                    onChange={selectChange}
                    id='vehicleMakeID'
                  >
                    <option selected value='0'>
                      Select Vehicle Make By
                    </option>
                    {state.vehicleMakeData.length > 0 &&
                      state.vehicleMakeData.map((data, index) => {
                        return (
                          <option key={index} value={data.vehicleMakeID}>
                            {data.vehicleMakeName}
                          </option>
                        )
                      })}
                  </select>
                  {formik.touched.vehicleMakeID && formik.errors.vehicleMakeID && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.vehicleMakeID}</div>
                    </div>
                  )}
                </div>
              </div>
              <div className='row mb-6'>
                <label className='col-lg-2 col-form-label fw-bold fs-6'>
                  <span className='required'>Model Name:</span>
                </label>
                <div className='col-lg-4 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid bg-light-primary'
                    placeholder='Enter Model Name'
                    {...formik.getFieldProps('vehicleModelName')}
                  />
                  {formik.touched.vehicleModelName && formik.errors.vehicleModelName && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.vehicleModelName}</div>
                    </div>
                  )}
                </div>
                <label className='col-lg-2 col-form-label fw-bold fs-6'>
                  <span className='required'>No of Seats:</span>
                </label>
                <div className='col-lg-4 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid bg-light-primary'
                    placeholder='Enter No of Seats'
                    {...formik.getFieldProps('noOfSeat')}
                  />
                  {formik.touched.noOfSeat && formik.errors.noOfSeat && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.noOfSeat}</div>
                    </div>
                  )}
                </div>
              </div>
              {/* 
              <div className='row mb-6'>
                  <label className='col-lg-2 col-form-label fw-bold fs-6'>
                  <span className='required'>Request Date:</span>
                </label>
                <div className='col-lg-4 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid bg-light-primary'
                    placeholder='Enter Request Date'
                    {...formik.getFieldProps('requestDate')}
                  />
                  {formik.touched.requestDate && formik.errors.requestDate && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.requestDate}</div>
                    </div>
                  )}
                </div>
                <label className='col-lg-2 col-form-label required fw-bold fs-6'>Status ID:</label>
                <div className='col-lg-4 fv-row'>
                  <select
                    className='form-select bg-light-primary'
                    aria-label='Default select example'
                    onChange={selectChange}
                    id='statusID'
                  >
                    <option selected value='0'>
                      Select Status
                    </option>
                    {modelStatusData.length > 0 &&
                      modelStatusData.map((data, index) => {
                        return (
                          <option key={index} value={data.statusID}>
                            {data.statusName}
                          </option>
                        )
                      })}
                  </select>
                  {formik.touched.statusID && formik.errors.statusID && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.statusID}</div>
                    </div>
                  )}
                </div>
              </div> */}
            </div>
            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button type='submit' className='btn btn-primary' disabled={loading}>
                {!loading && 'Submit'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <Link className='btn btn-danger ms-3' to='/vehicle/new-model-request/list'>
                Cancel
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export {AddNewModelRequest}
